<template>
  <div
    id="app"
    :class="{'is-mobile': isMobile}"
  >
    <!-- <SidebarComponent /> -->
    <router-view></router-view>
    <div id="signInContainer"></div>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
#app {
  display: flex;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  height: 100vh;
}

#signInContainer {
  z-index: 1000;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>